import { Flex } from '@mantine/core';
import { PlusCircle, Trash } from '@phosphor-icons/react';
import { CustomLabel } from 'components/elements/custom-form-control';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'components/styles';
import { CardContainer } from 'mantine-components/container/card-container';
import Input from 'mantine-components/elements';
import Button from 'mantine-components/widget/button';
import Text from 'mantine-components/widget/text';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { CruiseFormType } from './form-type';

export default function ShipSection() {
  const { t } = useTranslation();
  const { control } = useFormContext<CruiseFormType>();
  const { editable } = useFormState();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'cruiseShips',
    keyName: 'customId',
  });

  const onAddShip = React.useCallback(() => {
    append({
      name: '',
    });
  }, [append]);

  const onRemoveShip = React.useCallback(
    (index) => {
      remove(index);
    },
    [remove],
  );

  return (
    <CardContainer>
      <Text variant="headingXSmall">{t('cruise:ship')}</Text>
      <SeparatorVertical $margin={8} />
      <CustomLabel label={t('common:name')} required={editable} />
      <SeparatorVertical $margin={4} />
      {fields.map((field, idx) => (
        <React.Fragment key={field.customId}>
          <Flex gap={8}>
            <div style={{ flex: 1 }}>
              <Input
                type="text"
                name={`cruiseShips.${idx}.name`}
                placeholder={t('common:name')}
                required
              />
            </div>
            {editable && fields.length > 1 && (
              <Button
                variant="subtle"
                color="red"
                onClick={() => onRemoveShip(idx)}
              >
                <Trash size={20} />
              </Button>
            )}
          </Flex>
          <SeparatorVertical $margin={8} />
        </React.Fragment>
      ))}
      {editable && (
        <Button
          variant="outline"
          leftSection={<PlusCircle size={16} />}
          onClick={onAddShip}
          w="fit-content"
        >
          {t('common:add_extra', { extra: t('cruise:ship') })}
        </Button>
      )}
    </CardContainer>
  );
}
